import type { CommentListOrder } from '@/@types/comment'
import { useSelector } from '@tanstack/react-store'
import commentOrderStore from '@/utils/stores/commentOrder'
import CaretDownIcon from '@/assets/caret-down.svg?react'
import clsx from 'clsx'
import type { HTMLAttributes } from 'react'
import ClickWrapper, { type ClickWrapperProps } from '../ClickWrapper'
import DropdownMenu from '../DropdownMenu/DropdownMenu'
import styles from './CommentListOrderSelect.module.css'

const COMMENT_ORDER_LOCALE: Record<CommentListOrder, string> = {
	LIKES: '智能排序',
	TIME: '时间排序',
}

export type CommentListOrderSelectProps = HTMLAttributes<HTMLDivElement>

export default function CommentListOrderSelect(props: CommentListOrderSelectProps) {
	const order = useSelector(commentOrderStore)

	return (
		<DropdownMenu
			renderTrigger={(triggerProps) => (
				<ClickWrapper
					{...(triggerProps as ClickWrapperProps)}
					className={clsx(styles.trigger, triggerProps.className)}
				>
					<CaretDownIcon color="currentColor" className={styles.icon} />
					{COMMENT_ORDER_LOCALE[order]}
				</ClickWrapper>
			)}
			data={Object.entries(COMMENT_ORDER_LOCALE).map(([key, title]) => ({
				id: key,
				title: title,
			}))}
			position="bottom-end"
			onSelect={(menuId) => commentOrderStore.setState(() => menuId as CommentListOrder)}
		/>
	)
}
